<template>
  <div class="coupon-page">
    <!-- 头部导航 -->
    <AppHeader />

    <!-- Banner 区域 -->
    <div class="banner" :style="{ backgroundImage: 'url(' + bannerImage + ')' }"></div>

    <!-- 工会消费券 图文介绍 -->
    <section class="section intro-section">
      <div class="container intro-wrapper">
        <div class="intro-image">
          <img src="../src/assets/cp1.png" alt="工会消费券">
        </div>
        <div class="intro-content">
          <h2 class="intro-title">工会消费券</h2>
          <p style="line-height: 2;"> 基层工会可结合实际在现行规定基础上，每年发放一次工会消费券，用于购买日用消费品和文化旅游产品等。具体发放标准，发放方式和终止时限由基层工会确定。  </br>
           根据全总最新政策，工会文旅消费券是指由各级工会组织使用工会经费，向本单位会员发放的，专门用于日用消费品或文化旅游产品等。 </br>
           基层工会可结合实际在现行规定基础上，每年发放一次工会消费券，用于购买日用消费品和文化旅游产品等。具体发放标准，发放方式和终止时限由基层工会确定。 </br>
           根据全总最新政策，工会文旅消费券是指由各级工会组织使用工会经费，向本单位会员发放的，专门用于日用消费品或文化旅游产品等。 </p>
        </div>
      </div>
    </section>

    <!-- 服务优势 -->
    <section class="section advantage-section">
      <div class="container">
        <div class="section-label">SERVICE ADVANTAGE</div>
        <h2 class="section-heading">服务优势</h2>
        <p class="advantage-desc">
          我们支持根据各类采买需求，一对一量身定制专属页面。贴合企业采购流程、适配专属商品品类、匹配个性化权限设置，从品类分类、套餐搭配到权限管理、数据汇总，全维度按需定制。摒弃模板化束缚，贴合真实采买场景，专属页面精准适配你的采购节奏，简化采买流程、提升采购效率，省心又高效！
        </p>
        
        <div class="advantage-list">
          <div class="advantage-item">
            <div class="advantage-icon">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgjJXxzwYopJzd1QUwsAk4sAk!100x100.png" alt="专款专用">
            </div>
            <h3>专款专用</h3>
            <p>仅限文旅、日常用品消费，不得用于其他用途</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgvJTxzwYok-H33wYwsAk4sAk!100x100.png" alt="普惠性">
            </div>
            <h3>普惠性</h3>
            <p>面向全体工会会员，不得设置不合理门槛</p>
          </div>
          <div class="advantage-item">
            <div class="advantage-icon">
              <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgi5jxzwYovpP4-wcwsAk4sAk!100x100.png" alt="合规发放">
            </div>
            <h3>合规发放</h3>
            <p>必须使用工会经费，不得挪用行政经费</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 使用范围 -->
    <section class="section scope-section">
      <div class="container">
        <div class="section-label">SCOPE OF USE</div>
        <h2 class="section-heading">使用范围</h2>
        
        <div class="scope-grid">
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgwqbxzwYooJWB1gYw9AM43gc!500x500.png" alt="日常消费品">
            <span>日常消费品</span>
          </div>
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg1YS7zwYo-v7rrQIwzAQ4jgk!450x450.png" alt="电影演出">
            <span>电影演出</span>
          </div>
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg0YS7zwYomqCBcjCABDj2Bw!450x450.png" alt="文娱会员">
            <span>文娱会员</span>
          </div>
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgzIS7zwYorOHTqwEwgAQ49gc!450x450.png" alt="演出赛事">
            <span>演出赛事</span>
          </div>
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgwb6szwYogI0fMIAEOPYH!450x450.png" alt="蛋糕礼遇">
            <span>蛋糕礼遇</span>
          </div>
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgvKbxzwYogvKFlAYw9AM43gc!450x450.png" alt="图书频道">
            <span>图书频道</span>
          </div>
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAgyKbxzwYooMSO_AEw9AM43gc!450x450.png" alt="景区门票">
            <span>景区门票</span>
          </div>
          <div class="scope-item">
            <img src="//34188381.s21i.faiusr.com/4/ABUIABAEGAAg0qvxzwYorPbXyAYwyQM4-QY!450x450.png" alt="悦动态">
            <span>悦动态</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部信息 -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/head.vue'
import AppFooter from '@/components/foot.vue'

export default {
  name: 'UnionCoupon',
  components: {
    AppHeader,
    AppFooter
  },
  data () {
    return {
      bannerImage: require('../src/assets/cp2.png')
    }
  }
}
</script>

<style scoped>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif; color: #353535; line-height: 1.6; }

.coupon-page { background: #fff; }

/* Banner */
.banner {
  height: 800px;
  background-size: cover;
  background-position: 50% 50%;
}

/* 通用布局 */
.section { padding: 60px 0; }
.container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
.section-label {
  text-align: center;
  color: #e5e5e5;
  font-size: 36px;
  font-weight: bold;
  line-height: 1.2;
}
.section-heading {
  text-align: center;
  color: #353535;
  font-size: 36px;
  font-weight: bold;
  margin-bottom: 40px;
}

/* 工会消费券 图文介绍 */
.intro-section { padding: 80px 0; }
.intro-wrapper {
  display: flex;
  gap: 40px;
  align-items: center;
}
.intro-image {
  flex: 0 0 335px;
}
.intro-image img {
  width: 100%;
  display: block;
}
.intro-content {
  flex: 1;
  text-align: left;
}
.intro-title {
  font-size: 28px;
  color: #353535;
  font-weight: bold;
  margin-bottom: 25px;
}
.intro-content p {
  font-size: 18px;
  color: #666;
  line-height: 2.5;
  margin-bottom: 10px;
}

/* 服务优势 */
.advantage-section {
  background: #fafafa;
}
.advantage-desc {
  text-align: center;
  font-size: 16px;
  color: #4b4b4b;
  line-height: 30px;
  max-width: 1100px;
  margin: 0 auto 60px;
  letter-spacing: 1px;
}
.advantage-list {
  display: flex;
  justify-content: space-around;
  text-align: center;
}
.advantage-item {
  flex: 1;
  padding: 0 20px;
}
.advantage-icon {
  width: 100px;
  height: 100px;
  margin: 0 auto 20px;    background: #0a6ce8;
    border-radius: 50%;
    padding:16px;
}
.advantage-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.advantage-item h3 {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 15px;
}
.advantage-item p {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

/* 使用范围 */
.scope-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 50px;
}
.scope-item {
  width: 23%; /* 一行四个 */
  text-align: center;
}
.scope-item img {
  width: 100%;
  max-width: 230px;
  height: auto;
  margin-bottom: 15px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.scope-item span {
  font-size: 18px;
  color: #333;
  display: block;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .intro-wrapper {
    flex-direction: column;
  }
  .intro-image {
    flex: none;
    max-width: 100%;
    margin-bottom: 30px;
  }
  .advantage-list {
    flex-direction: column;
    gap: 40px;
  }
  .scope-item {
    width: 48%;
  }
}
</style>


// WEBPACK FOOTER //
// src/Coupon.vue